const donationOptions = {
    अभिषेक_देणगी: {
      "नित्य अभिषेक सेवा": 501,
      "रुद्राभिषेक सेवा": 701,
      "विशेष प्रसंगी प्रत्यक्ष महापूजा": 5001,
      "रुद्र एकादशनी अभिषेक सेवा": 2500,
      "लघुरूद्र अभिषेक सेवा": 11000,
      "पवमान अभिषेक सेवा": 2100,
      "लघुपवमान अभिषेक सेवा": 12000,
      "नित्य आरती सेवा": 501,
      "वैदिक मंत्रजागर": 1100,
      "पुष्पार्चन सेवा": 1001,
      "नित्य वस्त्रालंकार पूजा": 1001,
      "शाश्वत पूजा योजना": 3500,
      "नित्य अभिषेक सेवा ब्राह्मण भोजनासह": 701,
      "रुद्राभिषेक सेवा ब्राह्मण भोजनासह": 901,
      "विशेष प्रसंगी प्रत्यक्ष महापूजा ब्राह्मण भोजनासह": 10001,
      "रुद्र एकादशनी अभिषेक सेवा ब्राह्मण भोजनासह": 5000,
      "लघुरूद्र अभिषेक सेवा ब्राह्मण भोजनासह": 16000,
      "पवमान अभिषेक सेवा ब्राह्मण भोजनासह": 2300,
      "लघुपवमान अभिषेक सेवा ब्राह्मण भोजनासह": 14400
    },
    वेदपाठशाला_देणगी: {
      "एका विद्यार्थ्याचा एका महिन्याचा अन्न , वस्त्र.ग्रंथसहित खर्च": 4101,
      "एका विद्यार्थ्याचा एका वर्षाचा अन्न , वस्त्र , ग्रंथसहित खर्च": 45101,
      "एका विद्यार्थ्याचा एका महिन्याचा अन्न खर्च": 3101,
      "एका विद्यार्थ्याचा एका वर्षाचा केवळ वस्त्र व ग्रंथखर्च": 10001,
      "सर्व विद्यार्थ्यांचा एका महिन्याचा वैद्यकीय खर्च": 5000,
      "एका वर्षाचा वैद्यकीय खर्च": 50000,
      "गुरुकुलातील ब्रम्हवृदांचे भोजन व गोग्रास . एक दिवसाचा सर्व": 7001,
      "गुरूकुलास सहकार्य म्हणूनप्रतिमहिना": 500,
      "त्रैमासिक": 1000,
      "षण्मासिक": 2000,
      "वार्षिक": null,
      "पाठशाळेचे कार्य दीर्घकाळ पर्यंत चालावे याकरिता स्थायी निधी सहकार्य": null
    },
    अन्नदान_देणगी: {
      "द्वादशी निमित्त अन्नदान सेवा": null,
      "आमवास्या निमित्त": null,
      "जन्मोत्सव निमित्त": null,
      "वार्षिक उत्सव": null,
      "अधिकमास निमित्त": null,
      "ब्राह्मण दंपती भोजन": 501,
      "बटू भोजन (प्रति बटू)": 251,
      "द्वादशी निमित्त अन्नदान सेवा यजमानपद": 21000,
      "आमवास्या निमित्त यजमानपद": 11000
    },
    गोसेवा_देणगी: {
      "गोसेवा प्रकल्पातील एका गोमातेचा एक महिन्याचा चारा , पशुखाद्य इ . खर्च": 5001,
      "गोसेवा प्रकल्पासाठी सहकार्य": null,
      "गो प्रदान": null
    },
    इमारत_निधी: {
      "प्रतिष्ठान वास्तुविस्तार ,एका खोलीचा खर्च (खोलीस आपले नाव देण्यात येईल)": 100001
    },
    सामाजिक_उपक्रम_देणगी: {
      "आरोग्य शिबीर": null,
      "शिक्षण उपक्रम": null,
      "सांस्कृतिक कार्यक्रम": null,
      "पर्यावरण उपक्रम": null
    },
    अन्य: {
      "सर्वसाधारण सहकार्य": null,
      "विशेष प्रकल्प": null,
      "इतर": null
    }
  };

  export default donationOptions 